import React from "react";
import styled, {createGlobalStyle} from "styled-components";
import HorizontalScroll from "./HorizontalScroll";
import {Img} from "@chakra-ui/react";

const GlobalStyle = createGlobalStyle`
  * {
    box-sizing: border-box;
  }

  body {
    margin: 0;
  }
`;

const Main = styled.main``;

const HorizontalSection = styled.section`
  position: relative;
  width: 100%;
  min-height: 492px;
  @media screen and (min-width: 758px) {
    min-height: 700px;
  }
`;

const CardsContainer = styled.div`
  position: relative;
  // height: 492px;
  // @media screen and (min-width: 758px) {
  //  height: 700px;
  // }
  padding: 0;
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
`;

//height: 700px, width: 650px

const SampleCards = React.memo(({children}) => {
        return children.map((image, i) => {
            return (
                <Img
                    key={`sampleCard-${i}`}
                    height={['calc(100vh - 120px)', 'calc(100vh - 120px)']}
                    width={['auto', 'auto']}
                    maxWidth={'none'}
                    objectFit="contain"
                    objectPosition="bottom"
                    src={image?.carousel_item}
                    alt={`Carousel Image`}
                    position="relative"
                    flexShrink={0}
                    mr="15px"
                />
            )
        })

        // return Array(5)
        //     .fill(0)
        //     .map((_e, i) => <SampleCard key={`sampleCard-${i}`}/>)
    }
);

export const MarqueeSpring = ({data, children}) => { 
  // console.log("marquee", data);
  return (
    <>
        <GlobalStyle/>
        <Main>
            <HorizontalSection>
                <HorizontalScroll data={data}>
                    <CardsContainer>
                        <SampleCards children={children}/>
                    </CardsContainer>
                </HorizontalScroll>
            </HorizontalSection>

        </Main>
    </>
)};